export default __webpack_public_path__ + "static/media/officeSp.4b4364da.svg";